import { useMatchMedia } from '@lux/hooks';
import { screenSizes } from '@lux/core';

export type ColumnCount = 1 | 2 | 3 | 4;

/**
 * Custom hook for responsive column count using native matchMedia
 *
 * Uses standard Lux breakpoints for consistent responsive behavior:
 * - Mobile: 1 column (< sm)
 * - Tablet: 2 columns (sm - md)
 * - Desktop: 3 columns (md - lg)
 * - Large Desktop: 4 columns (>= lg)
 *
 * @returns Current column count that updates responsively
 */
export const useResponsiveColumns = (): ColumnCount => {
    const isTablet = useMatchMedia(`(min-width: ${screenSizes.xs}px) and (max-width: 801px)`);
    const isDesktop = useMatchMedia(`(min-width: 802px) and (max-width: 1077px)`);
    const isLargeDesktop = useMatchMedia(`(min-width: 1078px)`);

    if (isLargeDesktop) {
        return 4;
    }
    if (isDesktop) {
        return 3;
    }
    if (isTablet) {
        return 2;
    }
    return 1;
};
